module.exports = __webpack_public_path__ + "img/imagen-login.e47b3321.jpg";